import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getAllEvents } from "../../Api";

const BlogSection = ({ language = "EN" }) => {
  const [events, setEvents] = useState([]);
  const langKey = language === "CN" ? "zh" : "en";

  const IMAGE_BASE =
    process.env.REACT_APP_API_URL?.replace("/api", "") || "";

  useEffect(() => {
    getAllEvents()
      .then((res) => {
        if (res.data.success) {
          // 🔥 Latest 3 Events (Assuming newest first)
          const latestThree = res.data.data.slice(0, 3);
          setEvents(latestThree);
        }
      })
      .catch((err) => {
        console.error("Events Fetch Error:", err);
      });
  }, []);

  // 🔥 Description Limit Function
  const limitWords = (text, wordLimit = 18) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <section className="bg-[#f3f3f3] py-10">
      <div className="max-w-[1320px] mx-auto px-4">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
          <div>
            <p className="uppercase text-[#c69c6d] text-sm font-semibold mb-2">
              {language === "CN" ? "活动剪影" : "EVENT SNAPSHOT"}
            </p>
            <h2 className="text-3xl md:text-4xl font-medium text-[#1f3a44]">
              {language === "CN"
                ? "凝聚团队的精彩时刻"
                : "Moments that bring our team together."}
            </h2>
          </div>

         <Link
  to="/events"
  className="inline-block text-center mt-6 md:mt-0 mx-auto md:mx-0 bg-[#C2976C] text-white px-6 md:px-8 py-2.5 md:py-3 text-sm md:text-base font-semibold hover:bg-[#a88257] transition-colors duration-300"
>
  {language === "CN" ? "查看全部活动" : "View All Events"}
</Link>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">

          {events.map((event) => {
            const formattedDate = new Date(event.eventDate)
              .toLocaleDateString("en-GB", {
                year: "numeric",
                month: "short",
              });

            return (
              <div
                key={event._id}
                className="group bg-white overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
              >
                {/* Image (Only First Image) */}
                <div className="relative overflow-hidden">
                  <img
                    src={`${IMAGE_BASE}/${event.images?.[0]?.replace(/\\/g, "/")}`}
                    alt={event.title?.[langKey]}
                    className="w-full h-[200px] object-cover transition-transform duration-500 group-hover:scale-110"
                  />

                  {/* Overlay */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>

                  {/* Date Badge */}
                  <span className="absolute top-4 left-4 bg-[#c69c6d] text-white text-xs px-3 py-1">
                    {formattedDate}
                  </span>
                </div>

                {/* Content */}
                <div className="p-6">

                  <h3 className="relative text-lg font-semibold text-[#154059] mb-3 inline-block h-[50px]">
                    {event.title?.[langKey]}
                    <span className="absolute left-0 -bottom-1 w-0 h-[2px] bg-[#c69c6d] transition-all duration-300 group-hover:w-full"></span>
                  </h3>

                  <p className="text-sm text-gray-600 mb-4">
                    {limitWords(event.desc?.[langKey], 20)}
                  </p>

                  <Link
                    to="/events"
                    className="text-sm font-medium text-[#154059] inline-flex items-center gap-2 transition-all duration-300 group-hover:text-[#c69c6d]"
                  >
                    {language === "CN" ? "阅读更多" : "Read More"}
                    <span className="transform transition-transform duration-300 group-hover:translate-x-2">
                      →
                    </span>
                  </Link>

                </div>
              </div>
            );
          })}

        </div>

      </div>
    </section>
  );
};

export default BlogSection;